import React from 'react';
import { Col, Row } from 'reactstrap';

import getTargetName from 'services/forms/getTargetName';
import getTargetValue from 'services/forms/getTargetValue';
import IGlass from 'components/interfaces/IGlass';
import IGlassArea from 'components/interfaces/IGlassArea';
import IWall from 'components/interfaces/IWall';
import NumberInputField from 'components/layout/forms/NumberInputField';
import roundTwoDecimals from 'services/numbers/roundTwoDecimals';
import validGlassProperties from 'services/constants/validGlassProperties';
import { getGlassWeight } from 'components/configurator/services/glassWeight';

import 'style/configurator/modals/src/glassWall/glassAreas/GlassRow.css';

const GlassRow = ({
  disabledWidths,
  glass,
  glassArea,
  index,
  setGlassArea,
  wall,
  disabledInputs,
}: {
  disabledWidths: boolean;
  glass: IGlass;
  glassArea: IGlassArea;
  index: number;
  setGlassArea: (area: IGlassArea) => void;
  wall: IWall;
  disabledInputs?: boolean;
}): JSX.Element => {
  const glassSpacing = window.CommonFunctions.GetGlassGlassSpacing();

  const handleGlass = () => (e: any) => {
    const targetName = getTargetName(e);

    setGlassArea({
      ...glassArea,
      glasses: glassArea.glasses.map((existingGlass, existingGlassIndex) => {
        if (existingGlassIndex !== index) {
          return existingGlass;
        }

        return {
          ...existingGlass,
          [targetName]: getTargetValue(e),
        };
      }),
    });
  };

  const getWeight = () => {
    return roundTwoDecimals(getGlassWeight(glass.width, wall));
  };

  const getLengthError = () => {
    if (glass.width < validGlassProperties.length.min) {
      return `Should be at least ${validGlassProperties.length.min}mm`;
    }

    return undefined;
  };

  return (
    <div className="glass-row">
      {index === 0 ? null : (
        <Row>
          <Col>
            <div className="glass-spacing-width">
              <hr />
              <p>{glassSpacing}mm space</p>
            </div>
          </Col>
        </Row>
      )}
      <Row className="justify-content-md-center">
        <Col xs="3" className="name-cell">
          <p>
            {glassArea.name === ''
              ? index + 1
              : `${glassArea.name} / ${index + 1}`}
          </p>
        </Col>
        <Col>
          <NumberInputField
            error={getLengthError()}
            disabled={
              index === glassArea.glasses.length - 1 ||
              disabledWidths ||
              disabledInputs
            }
            id="width"
            name="width"
            onChange={handleGlass()}
            required
            value={glass.width}
          />
        </Col>
      </Row>
    </div>
  );
};

export default GlassRow;
